import {API_BASE_URL} from "@/config";

export async function cancelRequestedGoodie(goodieId, CsrfToken) {
    try {
        const response = await fetch(`${API_BASE_URL}/user-goodies/${goodieId}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': CsrfToken,
            },
            credentials: 'include',
        });
        if (response.status === 403) {
            this.$router.push({name: 'forbidden'});
        } else if (response.status === 404) {
            this.$router.push({name: 'not-found'});
        } else {
            await response.json();
            await this.fetchOrganisationGoodiesInfo();
        }
    } catch (error) {
        console.error('Error cancelling requested goodie:', error);
    }
}
